module.exports = "<section class='terms-preview mt-5 p-2'>\r\n    <terms-list list='$ctrl.list' button-action='$ctrl.fetchTermByID(id)'></terms-list>\r\n    <terms-dialog term='$ctrl.selectedTerm'></terms-dialog>\r\n</section>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/terms-preview/components/terms-page/terms-page.html
// module id = 2095
// module chunks = 0